"use strict";import{tag as e}from"../custom-tag.js";export function cartThickIcon({height:a=16,width:t=16,hidden:r=!1,title:l="Cart thick"}={}){return e`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${t}
      height=${a}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${r?"true":"false"}"
      role="img"
      aria-label="${l}"
    >
      <path
        fill="currentColor"
        d="M2.625 3c0-.207.168-.375.375-.375h2.25c.182 0 .338.13.37.31l.408 2.315H21a.375.375 0 0 1 .367.452l-1.5 7.125a.375.375 0 0 1-.367.298H7.418l.397 2.25H18.75a.375.375 0 0 1 0 .75H7.506a.374.374 0 0 1-.376-.316L4.935 3.375H3A.375.375 0 0 1 2.625 3m4.66 9.375h11.91L20.539 6H6.16zM5.625 19.5a1.875 1.875 0 1 1 3.75 0 1.875 1.875 0 0 1-3.75 0M7.5 18.375a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25m11.25-.75a1.875 1.875 0 1 0 0 3.75 1.875 1.875 0 0 0 0-3.75M17.625 19.5a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0"
      />
      <path
        stroke="currentColor"
        stroke-width=".5"
        d="M2.625 3c0-.207.168-.375.375-.375h2.25c.182 0 .338.13.37.31l.408 2.315H21a.375.375 0 0 1 .367.452l-1.5 7.125a.375.375 0 0 1-.367.298H7.418l.397 2.25H18.75a.375.375 0 0 1 0 .75H7.506a.374.374 0 0 1-.376-.316L4.935 3.375H3A.375.375 0 0 1 2.625 3Zm4.66 9.375h11.91L20.539 6H6.16zM5.625 19.5a1.875 1.875 0 1 1 3.75 0 1.875 1.875 0 0 1-3.75 0ZM7.5 18.375a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Zm11.25-.75a1.875 1.875 0 1 0 0 3.75 1.875 1.875 0 0 0 0-3.75ZM17.625 19.5a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Z"
      />
    </svg>
  `}
//# sourceMappingURL=cartThick.js.map
